module.exports = __webpack_public_path__ + "img/add.12b92d98.png";